var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMovements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.625 2.91667C10.2693 2.91667 10.7917 2.39433 10.7917 1.75C10.7917 1.10567 10.2693 0.583333 9.625 0.583333C8.98067 0.583333 8.45833 1.10567 8.45833 1.75C8.45833 2.39433 8.98067 2.91667 9.625 2.91667ZM6.5625 9.04167L5.6875 8.45833L4.97206 9.91667H2.1875C1.94588 9.91667 1.75 10.1125 1.75 10.3542C1.75 10.5958 1.94588 10.7917 2.1875 10.7917H5.25C5.41963 10.7917 5.57397 10.6936 5.64604 10.5401L6.5625 9.04167ZM9.16671 6.27083H10.9375C11.1792 6.27083 11.375 6.07496 11.375 5.83333C11.375 5.59171 11.1792 5.39583 10.9375 5.39583H9.54171L9.16671 6.27083ZM8.07173 3.07292C8.10484 3.06556 8.13825 3.06216 8.17132 3.06251C8.86729 3.06564 9.34223 3.76942 9.08339 4.41653L7.87732 7.43169L9.74041 9.27409C9.84047 9.34858 9.90415 9.46242 9.91499 9.5871L10.2067 12.9413C10.2276 13.182 10.0494 13.3941 9.8087 13.415C9.56799 13.436 9.35588 13.2578 9.33495 13.0171L9.06097 9.86632L6.68802 8.20525C6.30159 7.93475 6.1508 7.43471 6.32328 6.99568L7.45872 4.10549L5.89076 4.45392L5.37897 6.24519C5.31259 6.47752 5.07044 6.61204 4.83811 6.54567C4.60579 6.47929 4.47126 6.23714 4.53764 6.00481L5.12097 3.96314C5.16506 3.80884 5.29008 3.69106 5.44673 3.65625L8.07173 3.07292Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMovements);
export default __webpack_public_path__ + "static/media/iconMovements.42a6eaea5eaafccd7a694c37fe5eee2e.svg";
export { ForwardRef as ReactComponent };